import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

interface VideoWithLoaderProps {
  src: string; // Video source URL
  type?: string; // Video MIME type
  style?: React.CSSProperties; // Inline styles for the video
  controls?: boolean; // Whether to show controls
}

const VideoWithLoader: React.FC<VideoWithLoaderProps> = ({
  src,
  type = 'video/mp4',
  style = {},
  controls = true,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleCanPlay = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false); // Optionally log the error or show a fallback UI
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: style?.width || '100%',
        height: style?.height || '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {isLoading && (
        <CircularProgress
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
      <video
        style={{
          ...style,
          display: isLoading ? 'none' : 'block',
        }}
        controls={controls}
        onCanPlay={handleCanPlay}
        onError={handleError}
      >
        <source src={src} type="video/mp4" />
        <source src={src} type="video/quicktime" />
        Your browser does not support this video.
      </video>
    </Box>
  );
};

export default VideoWithLoader;
